import React from "react";
import "../css/delivery.scss";

export const POLICY_UPDATED = "October 16, 2026";
export const CONTACT_EMAIL = "zone@camartzuno.store";

export function ContactEmail() {
  return <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>;
}

function PolicyPage({ title, children, showUpdated = true }) {
  return (
    <main className="main-content" id="MainContent">
      <div className="shopify-policy__container">
        <div className="shopify-policy__title">
          <h1>{title}</h1>
        </div>
        <div className="shopify-policy__body">
          <div className="rte">
            {showUpdated && <p>Last updated: {POLICY_UPDATED}</p>}
            {children}
          </div>
        </div>
      </div>
    </main>
  );
}

export default PolicyPage;
